// @ts-generator-hash: 25507353d60d73a1ba0961985e0cb45cd0953f84654e60c295cb4936b885fcaf
// Generation date: 9/16/2025 8:34:04 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.Modules
export enum Modules {
  PA = 100,
  DC = 200,
  AP = 300,
  CO = 400,
  FO = 500,
}
